import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/modal-description.module.css';

function ModalDescription({ tag = 'p', className = null, ...props }: TypographyProps) {
    return (
        <Typography tag={tag} className={classNames([styles.container, className])} {...props} />
    );
}

export default ModalDescription;
